'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
interface ThemeSwitcherProps {
  className?: string;
}

// Use dynamic import to prevent hydration issues with localStorage
const DynamicThemeSwitcher = dynamic(() => import('@/app/_lib/ui/ThemeSwitch').then(mod => ({
  default: mod.ThemeSwitcher
})), {
  ssr: false,
  loading: () => <div className='w-4 h-4'></div> // Placeholder with same dimensions as icon
});
export function ThemeSwitcherWrapper(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <DynamicThemeSwitcher {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}